/* RESPONSIBLE TEAM: team-knowledge-foundations */
export default class BodyFilter {
  static type = 'body';
  static icon = 'long-text';
  static labelKey = 'articles.list.search.body-contains';

  static create({ value }: { value: string }) {
    return new BodyFilter(value);
  }

  type = BodyFilter.type;
  icon = BodyFilter.icon;
  labelKey = BodyFilter.labelKey;

  value: string;

  constructor(value: string) {
    this.value = value;
  }

  get text() {
    return this.value;
  }
}
